import type { ClientOverviewContactRow } from '../../clients/utils/getClientOverviewContacts';
import type { SessionClient } from '../data/mockSessionData';

const PREFERRED_EMERGENCY_ROLE = /emergency|spouse|partner|parent|guardian|contact/i;

/**
 * Prefer RelatedPerson / Patient.contact rows with a phone and emergency-style roles (e.g. spouse).
 */
export function pickEmergencyContactFromContactRows(
  rows: readonly ClientOverviewContactRow[],
): SessionClient['emergencyContact'] {
  const withPhone = rows.filter((r) => r.phone?.trim());
  const preferred =
    withPhone.find((r) => r.segments.some((s) => PREFERRED_EMERGENCY_ROLE.test(s.roleLabel))) ??
    withPhone[0];
  if (!preferred) {
    return { name: '—', relationship: '—', phone: '—' };
  }
  return {
    name: preferred.displayName,
    relationship: preferred.segments[0]?.roleLabel ?? '—',
    phone: preferred.phone ?? '—',
  };
}
